import React, { useEffect, useRef } from 'react';

const YouTubeEmbed = ({ videoId, onDurationChange }) => {
  const playerRef = useRef(null);
  
  useEffect(() => {
    // Try to get duration from YouTube iframe API
    const getDuration = () => {
      // Load YouTube iframe API
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        
        tag.onload = () => {
          // API loaded, create player when ready
          window.onYouTubeIframeAPIReady = createPlayer;
        };
        
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else if (window.YT && window.YT.Player) {
        // API already loaded, create player directly
        createPlayer();
      } else {
        // API script loaded but not initialized
        window.onYouTubeIframeAPIReady = createPlayer;
      }
    };
    
    // Create YouTube player that will get duration
    const createPlayer = () => {
      // Create a hidden player just to get duration
      try {
        const hiddenPlayer = new window.YT.Player('hidden-player', {
          videoId: videoId,
          events: {
            'onReady': (event) => {
              try {
                const duration = event.target.getDuration();
                if (duration && duration > 0) {
                  console.log(`Got video duration: ${duration} seconds`);
                  onDurationChange(duration);
                }
              } catch (err) {
                console.error('Error getting duration:', err);
              }
            },
            'onStateChange': (event) => {
              // Also try to get duration when playing starts
              if (event.data === window.YT.PlayerState.PLAYING) {
                try {
                  const duration = event.target.getDuration();
                  if (duration && duration > 0) {
                    onDurationChange(duration);
                  }
                } catch (err) {}
              }
            },
            'onError': (event) => {
              console.error('YouTube player error:', event.data);
            }
          },
          playerVars: {
            autoplay: 0,
            controls: 0
          }
        });
      } catch (err) {
        console.error('Error creating YouTube player:', err);
      }
    };
    
    // Start the process
    getDuration();
    
    // Cleanup function
    return () => {
      // Reset global callback if it's our function
      if (window.onYouTubeIframeAPIReady === createPlayer) {
        window.onYouTubeIframeAPIReady = null;
      }
    };
  }, [videoId, onDurationChange]);

  return (
    <>
      {/* Hidden player for API */}
      <div id="hidden-player" style={{ display: 'none' }}></div>
      
      {/* Visible iframe */}
      <div className="relative w-full h-0 pb-[56.25%]">
        <iframe 
          ref={playerRef}
          className="absolute top-0 left-0 w-full h-full"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </>
  );
};

export default YouTubeEmbed;
